import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

interface IProps {
  disabled?: boolean;
  hideFirstOption?: boolean;
  status?: string;
  width?: string;
  onChange?: ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const VehicleTypeSelect: React.FC<IProps> = memo(
  ({ hideFirstOption = false, disabled = false, status, width = 120, onChange }) => {
    return (
      <Select
        disabled={disabled}
        placeholder={L('Select type')}
        style={{ width }}
        value={status}
        onChange={onChange}
      >
        {!hideFirstOption && <Option value={undefined}>{L('All')}</Option>}
        <Option value="Sedan">{L('Sedan')}</Option>
        <Option value="Coupe">{L('Coupe')}</Option>
        <Option value="SUV">{L('SUV')}</Option>
        <Option value="StationWagon">{L('Station Wagon')}</Option>
        <Option value="SportsCar">{L('Sports Car')}</Option>
        <Option value="Hatchback">{L('Hatchback')}</Option>
        <Option value="Convertible">{L('Convertible')}</Option>
        <Option value="Minivan">{L('Minivan')}</Option>
        <Option value="PickupTruck">{L('Pickup Truck')}</Option>
      </Select>
    );
  }
);
